import React from 'react'
import ProdIOOQceExoRow from './ProdIOOQceExoRow'
import FormDialog from '../../../../../library/form/components/FormDialog';
import FormLabel from '../../../../../library/form/components/FormLabel';
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import useRowSelector from "../../../../../library/hooks/selector/useRowSelector";
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import { UiView, UiViewContent } from "../../../../../library/layout/Index";

const ProdIOOQceExo = (props) => {
    const { formObject, viewData, ...restProps } = props;

    const rowSelector = useRowSelector("2", null);

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel", confirmAction:"Are you sure to Confirm ?", confirmCancel:"Are you sure to Cancel ?" }, 
            actionParam: { selected: rowSelector.getSelectedRowsCS(), pathKey: "OQCE"} }}
            contentStyle={{ height: '300px' }}
            formStyle={{ width: '750px', height: '400px' }} formTitle={<SarasTrans value="Submit to QC" />}
        >
            <UiView>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn30"><SarasTrans value="Sr" /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                                    action={{ paramName: "variation1Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation1Name" }} value="Variation 1" />
                                </FormWrapper>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                                    action={{ paramName: "variation2Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation2Name" }} value="Variation 2" />
                                </FormWrapper>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Available Qty" /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Pending QC" /></li>
                                <li className="uiColumnCenter uiColumn130"><SarasTrans value="Submit QC Quantity" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li><ProdIOOQceExoRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index}  index={index + 1} /></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </FormDialog>
    )
}

export default withView(ProdIOOQceExo, "prodIOAddOQCE", "prodIOEOGroup");